<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Create Admin">
      <div class="row">
        <div class="col-md-4 form-group">
          Name
          <input class="form-control" v-model="name" @focus="nameEmpty = false" type="text" />
            <div v-if="nameEmpty" style="color: red">
            Name is required
          </div>
        </div>
        <div class="col-md-4 form-group">
          User Name
          <input class="form-control" v-model="username" @focus="usernameEmpty = false" type="text" />
          <div v-if="usernameEmpty" style="color: red">
            UserName is required
          </div>
        </div>
        <div class="col-md-4 form-group">
          Email
          <input class="form-control" v-model="email" @focus="emailEmpty = false" type="text" />
          <div v-if="emailEmpty" style="color: red">
            Email is required
          </div>
        </div>
        <div class="col-md-6 form-group">
          Password
          <input class="form-control" v-model="password" type="password" />
        </div>
        <div class="col-md-6 form-group">
          Confirm Password
          <input class="form-control" v-model="confirmpassword" @focus="confirmpasswordMatch = false" type="password" />
           <div v-if="confirmpasswordMatch" style="color: red">
             Password Does not match          
           </div>
        </div>
        <div class="col-md-6 form-group">
          Role
           <b-form-select v-model="role" @change="getRoles()" required>
            <option
              v-for="(role, index) in roles"
              :key="index"
              :value="role.id"
            >
              {{ role.role }}
            </option>
          </b-form-select>
           <div v-if="roleEmpty" style="color: red">
            Role is required
          </div>
        </div>
      </div>
      <div class="text-center">
      <b-button class="text-center pt-2 pb-2 pr-4 pl-4" variant="success" style="margin-bottom: 20px;" @click="update()">Save</b-button>
      </div>
    </base-block>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data(){
    return {
      name: "",
      nameEmpty:false,
      username: "",
      usernameEmpty:false,
      email: "",
      emailEmpty:false,
      password: "",
      passwordEmpty:false,
      confirmpassword:"",
      confirmpasswordMatch:false,
      role:"",
      roleEmpty:false,
      roles:[],
      admin:[],
    };
  },
   mounted() {
    this.getAdmins();
    this.getRoles();
  },
  methods: {
     async getAdmins() {
      await axios
        .get(`${this.$store.getters.baseUrl}/admins/edit/${this.$route.params.id}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if(response.data.status == "success") {
            this.admin = response.data.admin;
            this.name = response.data.admin.name;
            this.username = response.data.admin.username;
            this.email = response.data.admin.email;
            this.role = response.data.admin.role.id;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
          
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
     async getRoles() {
      await axios
        .get(`${this.$store.getters.baseUrl}/roles`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if(response.data.status == "success") {
            this.roles = response.data.roles;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
          
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async update() {

      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }
       if (this.username == "") {
        this.usernameEmpty = true;
        return;
      }
       if (this.email == "") {
        this.emailEmpty = true;
        return;
      }
        if (this.role == "") {
        this.roleEmpty = true;
        return;
      }
      if(!(this.confirmpassword == this.password)) {
        this.confirmpasswordMatch = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("name", this.name);
       formdata.append("username", this.username);
        formdata.append("email", this.email);
        if((this.password)){
          console.log('test');
         formdata.append("password", this.confirmpassword);
        }
          formdata.append("role", this.role);
      await axios
        .post(`${this.$store.getters.baseUrl}/admins/update/${this.$route.params.id}`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
           console.log(response);
          if (response.data.status == "success") {
            this.$swal("Success", "Admin Updated successfully", "success");
            this.$router.push({name: 'Tables Admin'});
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>

